import React, { useState, useEffect } from "react";
import CustomModal from "../../ui/CustomModal";

const BOMBA_METRIC_OPTIONS = [
  "O2","SO2","Temp","PRESS","Status","RLY","Vo",
  "TEMP_bckp","O2_bckp","SO2_bckp","elapsed_time"
];

const CAN_METRIC_OPTIONS = [
  "aviot","aviot_status","corriente","voltaje","source",
  "estado","hora","ipAddress","last_measure_press",
  "presion","sal"
];

export default function ConsoleMessagesModal({ open, onClose }) {
  const [bombaMetrics, setBombaMetrics] = useState(["O2","SO2","Temp"]);
  const [canMetrics, setCanMetrics] = useState(["ipAddress","corriente","voltaje"]);
  const [viewMode, setViewMode] = useState("module"); // "module" o "can"
  const [showCanTables, setShowCanTables] = useState(true);

  useEffect(() => {
    const config = JSON.parse(localStorage.getItem("consoleConfig")) || {};
    if (config.bombaMetrics) setBombaMetrics(config.bombaMetrics);
    if (config.canMetrics) setCanMetrics(config.canMetrics);
    if (config.viewMode) setViewMode(config.viewMode);
    if (typeof config.showCanTables === "boolean") setShowCanTables(config.showCanTables);
  }, [open]);

  const toggleMetric = (metric, setFunc, selected) => {
    setFunc(selected.includes(metric)
      ? selected.filter((m) => m !== metric)
      : [...selected, metric]);
  };

  const toggleAll = (options, selected, setFunc) => {
    if (selected.length === options.length) {
      setFunc([]); // deseleccionar todo
    } else {
      setFunc([...options]); // seleccionar todo
    }
  };

  const handleSave = () => {
    const config = JSON.parse(localStorage.getItem("consoleConfig")) || {};
    const newConfig = {
      ...config,
      bombaMetrics,
      canMetrics,
      viewMode,
      showCanTables,
    };
    localStorage.setItem("consoleConfig", JSON.stringify(newConfig));
    onClose();
  };

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Configurar Consola"
      actions={[
        { label: "Guardar", onClick: handleSave },
        { label: "Cancelar", onClick: onClose },
      ]}
    >
      <div
        className="console-config-form"
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
      >
        {/* === FILA 1: CAN === */}
        <div style={{ display: "flex", gap: "32px" }}>
          <div style={{ flex: 1 }}>
            <h4 style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Métricas de CAN</span>
              <button
                type="button"
                onClick={() => toggleAll(CAN_METRIC_OPTIONS, canMetrics, setCanMetrics)}
                style={{ fontSize: "12px", cursor: "pointer" }}
              >
                {canMetrics.length === CAN_METRIC_OPTIONS.length
                  ? "Deseleccionar todo"
                  : "Seleccionar todo"}
              </button>
            </h4>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {CAN_METRIC_OPTIONS.map((metric) => (
                <label key={metric} style={{ flex: "0 0 45%" }}>
                  <input
                    type="checkbox"
                    checked={canMetrics.includes(metric)}
                    onChange={() => toggleMetric(metric, setCanMetrics, canMetrics)}
                  />
                  {metric}
                </label>
              ))}
            </div>
          </div>

          <div style={{ flex: "0 0 200px" }}>
            <h4>Mostrar tablas de CAN</h4>
            <label>
              <input
                type="checkbox"
                checked={showCanTables}
                onChange={(e) => setShowCanTables(e.target.checked)}
              />
              Activar
            </label>
          </div>
        </div>

        {/* === FILA 2: Bombas + Vista === */}
        <div style={{ display: "flex", gap: "32px" }}>
          <div style={{ flex: 1 }}>
            <h4 style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Métricas de Bombas</span>
              <button
                type="button"
                onClick={() => toggleAll(BOMBA_METRIC_OPTIONS, bombaMetrics, setBombaMetrics)}
                style={{ fontSize: "12px", cursor: "pointer" }}
              >
                {bombaMetrics.length === BOMBA_METRIC_OPTIONS.length
                  ? "Deseleccionar todo"
                  : "Seleccionar todo"}
              </button>
            </h4>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {BOMBA_METRIC_OPTIONS.map((metric) => (
                <label key={metric} style={{ flex: "0 0 45%" }}>
                  <input
                    type="checkbox"
                    checked={bombaMetrics.includes(metric)}
                    onChange={() => toggleMetric(metric, setBombaMetrics, bombaMetrics)}
                  />
                  {metric}
                </label>
              ))}
            </div>
          </div>

          <div style={{ flex: "0 0 200px" }}>
            <h4>Vista</h4>
            <label>
              <input
                type="radio"
                name="viewMode"
                value="module"
                checked={viewMode === "module"}
                onChange={() => setViewMode("module")}
              />
              Por Módulo
            </label>
            <br />
            <label>
              <input
                type="radio"
                name="viewMode"
                value="can"
                checked={viewMode === "can"}
                onChange={() => setViewMode("can")}
              />
              Por CAN
            </label>
          </div>
        </div>
      </div>
    </CustomModal>
  );
}
